export const GET_COUNTRY_YEAR_GROUPS_REQUEST = 'GET_COUNTRY_YEAR_GROUPS_REQUEST';
export const GET_COUNTRY_YEAR_GROUPS_SUCCESS = 'GET_COUNTRY_YEAR_GROUPS_SUCCESS';
export const GET_COUNTRY_YEAR_GROUPS_FAILURE = 'GET_COUNTRY_YEAR_GROUPS_FAILURE';
export const CLEAR_COURSE_LIST = 'CLEAR_COURSE_LIST';
export const DESELECT_COURSE = 'DESELECT_COURSE';
export const GET_YEAR_GROUP_REQUEST = 'GET_YEAR_GROUP_REQUEST';
export const GET_YEAR_GROUP_SUCCESS = 'GET_YEAR_GROUP_SUCCESS';
export const GET_YEAR_GROUP_FAILURE = 'GET_YEAR_GROUP_FAILURE';
export const GET_COUNTRY_REQUEST = 'GET_COUNTRY_REQUEST';
export const GET_COUNTRY_SUCCESS = 'GET_COUNTRY_SUCCESS';
export const GET_COUNTRY_FAILURE = 'GET_COUNTRY_FAILURE';
export const GET_UPF_COUNTRY_REQUEST = 'GET_UPF_COUNTRY_REQUEST';
export const GET_UPF_COUNTRY_SUCCESS = 'GET_UPF_COUNTRY_SUCCESS';
export const GET_UPF_COUNTRY_FAILURE = 'GET_UPF_COUNTRY_FAILURE';
export const GET_PRODUCT_COURSE_REQUEST = 'GET_PRODUCT_COURSE_REQUEST';
export const GET_PRODUCT_COURSE_SUCCESS = 'GET_PRODUCT_COURSE_SUCCESS';
export const GET_PRODUCT_COURSE_FAILURE = 'GET_PRODUCT_COURSE_FAILURE';
export const GET_SCHOOL_COURSE_REQUEST = 'GET_SCHOOL_COURSE_REQUEST';
export const GET_SCHOOL_COURSE_SUCCESS = 'GET_SCHOOL_COURSE_SUCCESS';
export const GET_SCHOOL_COURSE_FAILURE = 'GET_SCHOOL_COURSE_FAILURE';
export const SHOW_COURSE_DETAILS = 'SHOW_COURSE_DETAILS';
export const GET_FILTERED_UPF_COURSES_REQUEST = 'GET_FILTERED_UPF_COURSES_REQUEST';
export const GET_FILTERED_UPF_COURSES_SUCCESS = 'GET_FILTERED_UPF_COURSES_SUCCESS';
export const GET_FILTERED_UPF_COURSES_FAILURE = 'GET_FILTERED_UPF_COURSES_FAILURE';



// WEBPACK FOOTER //
// ./app/containers/assign-courses-upf/action-types.js